'use strict';

angular.module('shiftTraderApp')
    .directive('saWorkPeriodMiniListItem', function ($location, $filter, $state) {
      return {
        templateUrl: 'views/directives/saWorkPeriodMiniListItem.html',
        restrict: 'EA',
        priority: 100,
        scope: {
          workPeriod: '=saWorkPeriodMiniListItem',
          getLinkUrl: '=linkFn',
          type: '@',
          hideDepartment: '@',
          hidePosition: '@',
          showTrade: '@'
        },
        link: function(scope) {
          scope.$state = $state;

          scope.showDepartmentBar = scope.type !== 'thin' && scope.hideDepartment !== 'true';
          scope.showPositionBar = scope.type !== 'thin' && scope.hidePosition !== 'true';
          scope.showEmployeeBar = scope.type === 'focus';
          scope.showPublishInfo = scope.type === 'focus';
          scope.showDayInfo = scope.type !== 'thin';
          scope.showTrade = scope.showTrade === 'true';

          scope.followLink = function() {
            $location.path(scope.getLinkUrl(scope.workPeriod).slice(2));
          };

          scope.isBeingTraded = scope.workPeriod.$isBeingTraded();
          scope.theTrade = scope.workPeriod.$getActiveTrade();

          if (scope.type === 'thin') {
            scope.topDateLineContent = $filter('uppercase')(scope.workPeriod.user.first_name);
            scope.bottomDateLineContent = $filter('uppercase')(scope.workPeriod.user.last_name);
          } else {
            scope.topDateLineContent = $filter('uppercase')(scope.workPeriod.start_time.format('MMM'));
            scope.bottomDateLineContent = $filter('uppercase')(scope.workPeriod.start_time.format('dddd'));
          }

        }
      };
    });
